// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mergeContainer {
  padding: 15px;
}

.mergeContainer .group {
  display: flex;
  flex-direction: column;
  margin: 10px 5px;
}

.mergeContainer .group label {
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/speakerslist/mergespeakerform/mergespeakerform.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".mergeContainer {\n  padding: 15px;\n}\n\n.mergeContainer .group {\n  display: flex;\n  flex-direction: column;\n  margin: 10px 5px;\n}\n\n.mergeContainer .group label {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
